module.exports = __webpack_public_path__ + "img/img1.f2c0c5c2.png";